import * as React from "react";
import { forwardRef } from "react";
const SvgDashedLine = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: 23, height: 23, viewBox: "0 0 104 7", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("line", { y1: 3.5, x2: 104, y2: 3.5, stroke: "black", strokeWidth: 7, strokeDasharray: "14 14" }));
const ForwardRef = forwardRef(SvgDashedLine);
export default ForwardRef;
